/* eslint-disable max-len */

import Log from '../../utils/Debug';

import {
  KEY_MANAGER_FETCH_KEYS,
  KEY_MANAGER_FETCH_KEYS_ERROR,
  KEY_MANAGER_FETCH_KEYS_LOADING,
  KEY_MANAGER_FETCH_KEYS_SUCCESS,
  KEY_MANAGER_CREATE_KEY,
  KEY_MANAGER_CREATE_KEY_ERROR,
  KEY_MANAGER_CREATE_KEY_LOADING,
  KEY_MANAGER_CREATE_KEY_SUCCESS,
  DISPLAY_CONFIRM,
  DISPLAY_PROGRESS,
  DISPLAY_SUCCESS,
  DISPLAY_ERROR,
} from './keyManagerConstants';

const initialState = {
  displayMode: DISPLAY_CONFIRM,
  keys: [],
  progress: 0,
  bearerToken: '',
  lastError: '',
  loading: false,
};

// Action Creators ::
export const fetchKeysAction = () => ({
  type: KEY_MANAGER_FETCH_KEYS,
});

export const fetchKeysErrorAction = error => ({
  error,
  type: KEY_MANAGER_FETCH_KEYS_ERROR,
});

export const fetchKeysLoadingAction = progress => ({
  progress,
  type: KEY_MANAGER_FETCH_KEYS_LOADING,
});

export const fetchKeysSuccessAction = keys => ({
  keys,
  type: KEY_MANAGER_FETCH_KEYS_SUCCESS,
});

// ----------------- >>

export const createKeyAction = () => ({
  type: KEY_MANAGER_CREATE_KEY,
  displayMode: DISPLAY_PROGRESS,
});

export const createKeyErrorAction = error => ({
  error,
  type: KEY_MANAGER_CREATE_KEY_ERROR,
  displayMode: DISPLAY_ERROR,
});

export const createKeyLoadingAction = progress => ({
  progress,
  type: KEY_MANAGER_CREATE_KEY_LOADING,
  displayMode: DISPLAY_PROGRESS,
});

export const createKeySuccessAction = token => ({
  token,
  type: KEY_MANAGER_CREATE_KEY_SUCCESS,
  displayMode: DISPLAY_SUCCESS,
});

export const clearLastErrorAction = () => ({
  error: null, type: KEY_MANAGER_CREATE_KEY_ERROR,
});

const keyManagerReducer = (state = initialState, action) => {
  switch (action.type) {
    case KEY_MANAGER_FETCH_KEYS:
      // Triggers the Saga Watcher
      return {
        ...state,
      };
    case KEY_MANAGER_FETCH_KEYS_ERROR:
      return {
        ...state,
        loading: false,
        lastError: action.error,
        keys: [],
      };
    case KEY_MANAGER_FETCH_KEYS_LOADING:
      return {
        ...state,
        loading: true,
        progress: action.progress,
        keys: action.keys,
      };
    case KEY_MANAGER_FETCH_KEYS_SUCCESS:
      return {
        ...state,
        loading: false,
        keys: action.keys,
      };

    // ----------------- >>
    case KEY_MANAGER_CREATE_KEY:
      Log.info(action, 'KEY_MANAGER_CREATE_KEY');
      return {
        ...state,
        displayMode: action.displayMode,
      };
    case KEY_MANAGER_CREATE_KEY_ERROR:
      Log.info(action, 'KEY_MANAGER_CREATE_KEY_ERROR');
      return {
        ...state,
        displayMode: action.displayMode || state.displayMode,
        lastError: action.error,
        bearerToken: '',
      };
      // Todo: handle logging error
    case KEY_MANAGER_CREATE_KEY_LOADING:
      Log.info(action, 'KEY_MANAGER_CREATE_KEY_LOADING');
      return {
        ...state,
        progress: action.progress,
        displayMode: action.displayMode,
      };
    case KEY_MANAGER_CREATE_KEY_SUCCESS:
      Log.info(action, 'KEY_MANAGER_CREATE_KEY_SUCCESS');
      return {
        ...state,
        displayMode: action.displayMode,
        bearerToken: action.token,
      };
    default:
      return state;
  }
};

export default keyManagerReducer;
